<template>
    <div class="form-group">
        <label :for="getId">{{ label }}</label>
        <div class="input-group" v-if="withCount">
            <textarea :id="getId" :cols="cols" :rows="rows" class="form-control" v-model="internalValue"></textarea>
            <span class="input-group-addon" :id="getId">{{ getCharacterCount }} {{ countLabel }}</span>
        </div>
        <textarea :id="getId" :cols="cols" :rows="rows" class="form-control" v-model="internalValue" v-if="withCount === false"></textarea>
    </div>
</template>

<script>
export default {
    name: "ifp-textarea",
    props: {
        value: {
            require: true
        },
        id: {
            type: String,
            required: false,
            default: ''
        },
        label: {
            type: String,
            required: true
        },
        cols: {
            type: String,
            required: false,
            default: '30'
        },
        rows: {
            type: String,
            required: false,
            default: '10'
        },
        withCount: {
            type: Boolean,
            required: false,
            default: false
        },
        countLabel: {
            type: String,
            required: false,
            default: 'characters'
        }
    },
    data() {
        return {
            internalValue: ''
        };
    },
    computed: {
        getId() {
            return (this.id.length === 0) ? this.slugify(this.label) : this.id;
        },
        getPlaceholder() {
            return (this.placeholder.length === 0) ? this.label : this.placeholder;
        },
        getCharacterCount() {
            return this.internalValue ? this.internalValue.length : 0;
        }
    },
    methods: {
        slugify(text) {
            return text.toString().toLowerCase()
                .replace(/\s+/g, '_')           // Replace spaces with -
                .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                .replace(/\-\-+/g, '_')         // Replace multiple - with single -
                .replace(/^_+/, '')             // Trim - from start of text
                .replace(/_+$/, '');            // Trim - from end of text
        }
    },
    watch: {
        value(newValue, oldValue) {
            if (newValue !== null && newValue !== this.internalValue) {
                this.internalValue = newValue;
            }
        },
        internalValue(newValue, oldValue) {
            this.$emit('input', newValue)
        }
    }
}
</script>

<style scoped>

</style>